/**
 * Created by piotr.pozniak@thebeaverhead.com on 12/06/2021.
 */

import { CT, IT } from "../../../consts";

export const definitions = {
  title: "Events",
  icon: "display_settings",
  groups: [
    {
      label: "Detailed list",
      options: [
        {
          title: "Show event date",
          templates: [CT.detailedList],
          name: "dLShowDate",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Show location",
          templates: [CT.detailedList],
          name: "dLShowLocation",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show description",
          templates: [CT.detailedList],
          integrations: [IT.google],
          name: "dLShowDescription",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Description length",
          templates: [CT.detailedList],
          integrations: [IT.google],
          name: "dLSummaryLength",
          defaultValue: "clamp",
          tooltip: null,
          show: [{ field: "dLShowDescription", value: 1, defaultValue: 1 }],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Full description", value: "full" },
                { label: "Line clamp", value: "clamp" },
              ],
            },
          },
        },
        {
          title: "Clamped length",
          templates: [CT.detailedList],
          integrations: [IT.google],
          name: "dLClampedLength",
          defaultValue: "2",
          tooltip: null,
          show: [
            { field: "dLSummaryLength", value: "clamp", defaultValue: "clamp" },
            { field: "dLShowDescription", value: 1, defaultValue: 1 },
          ],
          style: {
            selector: [".line-clamp"],
            property: "-webkit-line-clamp",
          },
          control: {
            kind: "number",
            placeholder: "Line clamp",
            options: { min: 1, placeholder: "Line clamp" },
          },
        },
      ],
    },
    {
      label: "Weekly View Events",
      options: [
        {
          title: "Display events as",
          templates: [CT.weekly],
          name: "wwEventsLocation",
          defaultValue: "events_list",
          tooltip: null,
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Events List", value: "events_list" },
                { label: "Pills", value: "pills" },
                { label: "Stacks", value: "stack" },
              ],
              updateValue: (val) => {
                if (val[0].value == "events_list") {
                  val.push({
                    field: "generalOpenDetailsModal",
                    value: 0,
                  });
                } else {
                  val.push({
                    field: "generalExpandDetailAccording",
                    value: 0,
                  });
                }
                return val;
              },
            },
          },
        },
        {
          title: "Show events indication",
          templates: [CT.weekly],
          name: "wwShowEventsIndication",
          defaultValue: 1,
          tooltip: null,
          dependency: {
            field: "wwEventsLocation",
            value: "events_list",
            defaultValue: "events_list",
            message: "Only applicable when displaying event details in list",
          },
          show: [
            {
              field: "wwEventsLocation",
              value: "events_list",
              defaultValue: "events_list",
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: (
            <span>
              Today as first day{" "}
              <span className={"badge badge-success"}>NEW</span>
            </span>
          ),
          templates: [CT.weekly],
          name: "wwStartFromToday",
          defaultValue: 0,
          tooltip: {
            message:
              "Show today as the first column. Arrows move forward and back from today",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: (
            <span>
              Days to show <span className={"badge badge-success"}>NEW</span>
            </span>
          ),
          templates: [CT.weekly],
          name: "wwDaysCount",
          defaultValue: "7",
          tooltip: {
            message:
              "Number of days visible at once. Navigation moves by this many days.",
          },
          show: [
            {
              field: "wwStartFromToday",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                {
                  label: "7",
                  value: "7",
                },
                {
                  label: "6",
                  value: "6",
                },
                {
                  label: "5",
                  value: "5",
                },
                {
                  label: "4",
                  value: "4",
                },
                {
                  label: "3",
                  value: "3",
                },
              ],
            },
          },
        },
        {
          title: "Display location in pill or stack",
          templates: [CT.weekly],
          name: "wwShowEventLocation",
          defaultValue: 0,
          tooltip: null,
          show: [
            {
              field: "wwEventsLocation",
              value: "pills",
              defaultValue: "events_list",
            },
            {
              field: "wwEventsLocation",
              value: "stack",
              defaultValue: "events_list",
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
      ],
    },
    {
      label: "Cards template",
      options: [
        {
          title: "Align buttons across cards",
          templates: [CT.card, CT.cardList],
          name: "ccCardEqHeight",
          defaultValue: 0,
          show: [{ field: "cCardShowCta1st", value: 1, defaultValue: 0 }],
          tooltip: {
            message:
              "Keeps buttons aligned across cards, even when titles or other details vary in length",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Show image container",
          templates: [CT.cardList, CT.cardSlider, CT.card],
          name: "eventDetailsShowImageContainer",
          defaultValue: 1,
          tooltip: {
            message:
              "Show / Hide the image and all other details in this area.",
            url: "https://help.display.church/en/articles/9063894-design-events-show-image-container",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Image aspect ratio",
          templates: [CT.cardList, CT.cardSlider, CT.card],
          name: "ccImageAspectRatio",
          defaultValue: "169",
          tooltip: null,
          show: [
            {
              field: "eventDetailsShowImageContainer",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                {
                  label: "40 viewport height",
                  value: "eventon",
                },
                { label: "1:1", value: "11" },
                { label: "3:2", value: "32" },
                { label: "4:3", value: "43" },
                { label: "3:4", value: "34" },
                { label: "16:9", value: "169" },
              ],
            },
          },
        },
        {
          title: "Date location",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cwDateLocation",
          defaultValue: "bottom-right",
          tooltip: {
            url: "https://help.display.church/en/articles/4900979-design-events-card-view-date-location",
            message:
              "Card list/grid views: Show/hide event date on image of card.",
          },
          show: [
            {
              field: "eventDetailsShowImageContainer",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Display Date in top left corner", value: "top-left" },
                {
                  label: "Display Date in top right corner",
                  value: "top-right",
                },
                {
                  label: "Display Date in bottom right corner",
                  value: "bottom-right",
                },
                {
                  label: "Display Date in bottom left corner",
                  value: "bottom-left",
                },
                { label: "Don't display date", value: "none" },
              ],
            },
          },
        },
        {
          title: "Show event title in card",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "ccShowTitle",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show date in card",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "ccShowDate",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4901457-design-events-show-date-in-card",
            message:
              "Card list/grid views: Show/hide event date in details section of card.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "",
          templates: [CT.cardList, CT.card, CT.cardSlider],
          name: "ccShowTimeOptions",
          defaultValue: "regular",
          tooltip: null,
          show: [
            {
              field: "ccShowDate",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Regular", value: "regular" },
                { label: "Compact", value: "compact" },
                { label: "Short", value: "short" },
              ],
            },
          },
        },
        {
          title: "Show location in card",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          integrations: [IT.google],
          name: "ccShowLocation",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4896407-design-events-show-location-in-card",
            message:
              "Card list/grid views: Show event locations in details section of cards.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show description in card",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          integrations: [IT.google],
          name: "ccShowDescription",
          applicable: "design",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4901500-design-events-show-description-in-card",
            message:
              "Card list/grid views: Show/hide event description in the details section of the card.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show description in card",
          templates: [CT.card, CT.cardSlider],
          integrations: [IT.google],
          name: "ccShowDescription",
          applicable: "highlights",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4901500-design-events-show-description-in-card",
            message:
              "Card list/grid views: Show/hide event description in the details section of the card.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show description in card",
          templates: [CT.cardList],
          integrations: [IT.google],
          name: "ccShowDescription",
          applicable: "highlights",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4901500-design-events-show-description-in-card",
            message:
              "Card list/grid views: Show/hide event description in the details section of the card.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Description length",
          templates: [CT.card, CT.cardList, CT.cardSlider, CT.cardList],
          integrations: [IT.google],
          name: "ccDescriptionLength",
          defaultValue: "clamp",
          tooltip: null,
          show: [{ field: "ccShowDescription", value: 1, defaultValue: 0 }],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Full description", value: "full" },
                { label: "First paragraph clamp", value: "clamp_paragraph" },
                { label: "Line clamp", value: "clamp" },
              ],
            },
          },
        },
        {
          title: "Show tags in card",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccShowTags",
          defaultValue: 0,
          applicable: "design",
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Tag color",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagColor",
          defaultValue: "#424242",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag",
            ],
            property: "color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "color",
            options: {},
          },
        },
        {
          title: "Tag color on over",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagColorHover",
          defaultValue: "#424242",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag:hover",
            ],
            property: "color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "color",
            options: {},
          },
        },
        {
          title: "Tag size",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagFontSize",
          defaultValue: "1em",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag",
            ],
            property: "font-size",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "cssDimension",
            options: { placeholder: "CSS value for font size" },
          },
        },
        {
          title: "Show tags as pills",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccShowTagsAsPills",
          defaultValue: 0,
          applicable: "design",
          tooltip: null,
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Tag pill padding",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagPillPadding",
          defaultValue: "0.2em 0.4em 0.2em 0.4em",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-tags-tag.card-view--card-content-tags-tag_border",
            ],
            property: "padding",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowTagsAsPills",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "cssBox",
            options: {
              placeholder: "CSS value for padding",
              step: 0.1,
            },
          },
        },
        {
          title: "Tag pill color",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagPillBg",
          defaultValue: "#FBFBFB",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag.card-view--card-content-tags-tag_border",
            ],
            property: "background-color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowTagsAsPills",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "color",
            options: { showTransparentOption: true },
          },
        },
        {
          title: "Tag pill color Hover",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagPillBgHover",
          defaultValue: "#FBFBFB",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag.card-view--card-content-tags-tag_border:hover",
            ],
            property: "background-color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowTagsAsPills",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "color",
            options: { showTransparentOption: true },
          },
        },
        {
          title: "Tag pill border width",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagPillBorderWidth",
          defaultValue: "0.1em",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag.card-view--card-content-tags-tag_border",
            ],
            property: "border-width",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowTagsAsPills",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "cssDimension",
            options: { placeholder: "CSS value for border size" },
          },
        },
        {
          title: "Tag pill border",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagPillBorderColor",
          defaultValue: "#A6A6A6FF",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag.card-view--card-content-tags-tag_border",
            ],
            property: "border-color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowTagsAsPills",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "color",
            options: { showTransparentOption: true },
          },
        },
        {
          title: "Tag pill border on hover",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagPillBorderColorHover",
          defaultValue: "#A6A6A6FF",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag:hover.card-view--card-content-tags-tag_border",
            ],
            property: "border-color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowTagsAsPills",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "color",
            options: { showTransparentOption: true },
          },
        },
        {
          title: "Show # next to tag label",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccShowSign",
          defaultValue: 1,
          applicable: "design",
          tooltip: null,
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Tag # color",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagSignColor",
          defaultValue: "#424242",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag .card-view--card-content-tags-tag-sign",
            ],
            property: "color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccShowSign",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
            options: {},
          },
        },
        {
          title: "Tag # on over",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccTagSignColorHover",
          defaultValue: "#424242",
          applicable: "design",
          tooltip: null,
          style: {
            selector: [
              ".card-view--card-content-body .card-view--card-content-tags .card-view--card-content-tags-tag:hover .card-view--card-content-tags-tag-sign",
            ],
            property: "color",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },

            {
              field: "ccShowSign",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
            options: {},
          },
        },
        {
          title: "Limit tags in card",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccLimitTags",
          defaultValue: 0,
          applicable: "design",
          tooltip: null,
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Number of tags to show",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccLimitTagsNumber",
          defaultValue: 3,
          applicable: "design",
          tooltip: null,
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
            {
              field: "ccLimitTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "number",
            min: 0,
            options: {},
          },
        },
        {
          title: "Omit the following tags",
          templates: [CT.cardList, CT.card],
          integrations: [IT.google],
          name: "ccRejectedTags",
          defaultValue: "",
          applicable: "design",
          tooltip: {
            message: "Comma-separated list of tags you wish not to show.",
          },
          show: [
            {
              field: "ccShowTags",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "text",
            options: {},
          },
        },
      ],
    },
    {
      label: "Full calendar behavior",
      options: [
        {
          title: "Hide events list",
          templates: [CT.monthly],
          name: "mcHideEventsList",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4572054-design-events-hide-events-list",
            message: "Full calendar: do not show the lists of events",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "On mouse hover, show only Number of Events for cell",
          templates: [CT.monthly],
          name: "mcShowEventsCounter",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4571942-design-events-number-details-names",
            message: "Full calendar only: number of daily events (mouseover)",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "On mouse hover, show both Number and Event details for cell",
          templates: [CT.monthly],
          name: "mcShowEventsDetailedInfo",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4571942-design-events-number-details-names",
            message:
              "Full calendar only: number and names of daily events (mouseover)",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show Event names in cell",
          templates: [CT.monthly],
          name: "mcShowEventsNames",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4571942-design-events-number-details-names",
            message: "Full calendar: names of daily events",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Selecting day opens modal with events list",
          templates: [CT.monthly],
          name: "mcShowNamesShowsDetails",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4572014-design-events-events-list-modal",
            message: "Full calendar: pop up with event details",
          },
          /*          dependency: {
            name: "mcShowEventsNames",
            value: 1,
            defaultValue: 0,
            message:
              "This option requires 'Show Event names in cell' to be turned on.",
          },*/
          control: {
            kind: "checkbox",
            options: {},
          },
        },
      ],
    },
    {
      label: "Event details",
      options: [
        {
          title: "Show timezone next to event time",
          templates: [
            CT.monthly,
            CT.eventList,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
          ],
          name: "generalShowTz",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/5555606-design-events-show-timezone-next-to-event-time",
            message:
              "Event times are shown in local time. Highlight this with the timezone.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Use calendar color as accent color",
          templates: [
            CT.monthly,
            CT.eventList,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "generalUseEventAccent",
          integrations: [IT.google],
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/5799302-design-events-use-calendar-color-as-accent-color-gcal",
            message:
              "Color of event listing left border; image space if no image.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Expand event details like an accordion",
          templates: [CT.monthly, CT.eventList],
          name: "generalExpandDetailAccording",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4572067-design-events-event-details-as-accordion-or-pop-up",
            message:
              "Event details in accordion format for calendars and events lists.",
          },
          checkDependency: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            { field: "generalOpenDetailsModal", value: 1, defaultValue: 0 },
          ],
          dependency: {
            field: "generalOpenDetailsModal",
            value: 0,
            defaultValue: 0,
            message: "Either accordion or modal is allowed",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        // this option is for weekly view only!
        {
          title: "Expand event details like an accordion",
          templates: [CT.weekly],
          name: "generalExpandDetailAccording",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4572067-design-events-event-details-as-accordion-or-pop-up",
            message:
              "Event details in accordion format for calendars and events lists.",
          },
          show: [
            {
              field: "wwEventsLocation",
              value: "events_list",
              defaultValue: "events_list",
            },
          ],
          checkDependency: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            { field: "generalOpenDetailsModal", value: 1, defaultValue: 0 },
          ],
          dependency: {
            field: "generalOpenDetailsModal",
            value: 0,
            defaultValue: 0,
            message: "Either accordion or modal is allowed",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Open event details as a pop-up",
          templates: [CT.eventList, CT.weekly, CT.monthly],
          name: "generalOpenDetailsModal",
          applicable: "design",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4572067-design-events-event-details-as-accordion-or-pop-up",
            message:
              "Event details as a pop-up (modal) for calendars and events lists.",
          },
          checkDependency: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            { field: "generalOpenDetailsModal", value: 1, defaultValue: 0 },
          ],
          dependency: {
            field: "generalExpandDetailAccording",
            value: 0,
            defaultValue: 1,
            message: "Either accordion or modal is allowed",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Open event details as a pop-up",
          templates: [CT.cardList, CT.card, CT.cardSlider],
          name: "generalOpenDetailsModal",
          applicable: "design",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4572067-design-events-event-details-as-accordion-or-pop-up",
            message:
              "Event details as a pop-up (modal) for calendars and events lists.",
          },
          checkDependency: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 0,
            },
            { field: "generalOpenDetailsModal", value: 1, defaultValue: 0 },
          ],
          dependency: {
            field: "generalExpandDetailAccording",
            value: 0,
            defaultValue: 1,
            message: "Either accordion or modal is allowed",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Open event details as a pop-up",
          templates: [CT.detailedList, CT.bubble],
          name: "generalOpenDetailsModal",
          applicable: "design",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4572067-design-events-event-details-as-accordion-or-pop-up",
            message:
              "Event details as a pop-up (modal) for calendars and events lists.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Open event details as a pop-up",
          templates: [CT.card, CT.cardList, CT.cardSlider, CT.bubble],
          name: "generalOpenDetailsModal",
          applicable: "highlights",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4572067-design-events-event-details-as-accordion-or-pop-up",
            message:
              "Event details as a pop-up (modal) for calendars and events lists.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Show summary header on pop-up",
          templates: [
            CT.monthly,
            CT.eventList,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "generalShowEventSummary",
          defaultValue: 1,
          show: [
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: {
            url: "https://help.display.church/en/articles/5788056-design-events-show-summary-on-pop-up",
            message: "Header of event name, date, time, & location.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Show event description",
          templates: [
            CT.monthly,
            CT.eventList,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "generalShowDescription",
          defaultValue: 1,
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          tooltip: {
            url: "https://help.display.church/en/articles/6065215-design-events-show-event-description",
            message: "Show/hide event explanation.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Underline description links",
          templates: [
            CT.monthly,
            CT.eventList,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "generalUnderlineLinks",
          defaultValue: 1,
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show event location in header",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eLShowLocation",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show event location",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          integrations: [IT.google],
          name: "eventDetailsShowLocation",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4667095-design-events-show-event-location",
            message:
              "Display event location for all calendars and event lists.",
          },
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show link to Google Maps",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          tooltip: {
            url: "https://help.display.church/en/articles/4667095-design-events-show-event-location-link-location-to-google-maps",
            message: "Display clickable link to Google map.",
          },
          name: "eventDetailsLinkLocation",
          defaultValue: 1,
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show Location's Google Maps photos if available",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          integrations: [IT.google],
          tooltip: null,
          name: "cPopupShowPlace",
          defaultValue: 1,
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show event time",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowTime",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/5788093-design-events-show-event-time",
            message: "If showing event time, choose the format.",
          },
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowTimeOptions",
          defaultValue: "regular",
          tooltip: null,
          show: [
            {
              field: "eventDetailsShowTime",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Regular", value: "regular" },
                { label: "Compact", value: "compact" },
                { label: "Short", value: "short" },
              ],
            },
          },
        },

        {
          title: "Show image when available",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowImage",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4628925-design-events-show-image-when-available",
            message: "Display event image for all calendars and event lists.",
          },
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Image aspect ratio",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsImageAspectRatio",
          defaultValue: "169",
          tooltip: {
            url: "https://help.display.church/en/articles/5393644-design-events-image-aspect-ratio-image-object-fit",
            message: "Adjust length and height of image",
          },
          show: [
            {
              field: "eventDetailsShowImage",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                {
                  label: "40 viewport height",
                  value: "eventon",
                },
                { label: "1:1", value: "11" },
                { label: "3:2", value: "32" },
                { label: "4:3", value: "43" },
                { label: "16:9", value: "169" },
              ],
            },
          },
        },
        {
          title: "Image object fit",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsImageObjectFit",
          defaultValue: "cover",
          tooltip: {
            url: "https://help.display.church/en/articles/5393644-design-events-image-aspect-ratio-image-object-fit",
            message: "Choose how image fills the given space",
          },
          style: [
            {
              selector: ".event-row--image-container .event-row--image",
              property: "object-fit",
            },
          ],
          show: [
            {
              field: "eventDetailsShowImageContainer",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "eventDetailsShowImage",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Cover", value: "cover" },
                { label: "Contain", value: "contain" },
                { label: "Fill", value: "fill" },
              ],
            },
          },
        },

        {
          title: "Show share calendar button",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowShareOptions",
          defaultValue: 1,
          tooltip: null,
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        /*{
          title: "Show subscribe calendar button",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowAddToCalendar",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/4616084-design-events-show-add-to-calendar",
            message:
              "For all calendars and event lists: links so viewer can add to personal/app calendars.",
          },
          show: [
            {
              field: "generalExpandDetailAccording",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 0,
              or: true,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },*/
        {
          title: "Show recurring events times",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowRepeatingEventsTimes",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/6328049-design-events-event-details-recurring-events-times-series",
            message: "Show/hide frequency and hours of the recurring event.",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show recurrence series",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          integrations: [IT.google],
          name: "eventDetailsShowRecurringSeries",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/6328049-design-events-event-details-recurring-events-times-series",
            message:
              "Show/hide schedule of day, date, hours of recurring event.",
          },
          show: [
            {
              field: "eventDetailsShowRepeatingEventsTimes",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show workspace branding",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          integrations: [IT.google],
          name: "eventDetailsShowBranding",
          defaultValue: 0,
          tooltip: null,

          control: {
            kind: "checkbox",
            options: {},
          },
        },
      ],
    },
    {
      label: "Details enhancement",
      options: [
        {
          title: "Turn video links into preview",
          templates: [
            CT.monthly,
            CT.eventList,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "turnVideoLinkIntoPreview",
          defaultValue: 1,
          tooltip: {
            url: "https://help.display.church/en/articles/9286370-design-events-details-enhancements-turn-video-links-into-preview",
            message:
              "Turn Youtube and Vimeo links into a preview image for all calendars and event lists.",
          },
          show: [
            {
              field: "generalShowDescription",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: (
            <span>
              Hide description links matching the CTA button{" "}
              <span className={"badge badge-success"}>NEW</span>
            </span>
          ),
          templates: [
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
            CT.monthly,
            CT.weekly,
          ],
          integrations: [IT.google],
          name: "eventDetailsHideDescriptionCtaLinks",
          defaultValue: 0,
          show: [
            {
              field: "cPopupShowCta1st",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: { kind: "checkbox", options: {} },
        },
      ],
    },
    {
      label: "Event list/card/grid details",
      options: [
        {
          title: "Show day of the week",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "eventDetailsShowDayOfWeek",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4925816-design-events-show-day-of-the-week-in-event-list-grid",
            message:
              "All views except weekly: Show/hide weekday name in event list/grid.",
          },

          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Day of the week length",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "eventsShowDayWeekOption",
          defaultValue: "ddd",
          tooltip: null,
          show: [
            {
              field: "eventDetailsShowDayOfWeek",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Narrow (eg. S, M,...)", value: "dd" },
                { label: "Short (eg. Sun, Mon, ...)", value: "ddd" },
                {
                  label: "Full (eg. Sunday, Monday, ...)",
                  value: "dddd",
                },
              ],
            },
          },
        },
      ],
    },
    {
      label: "Number of events",
      options: [
        {
          title: "Infinite scroll",
          templates: [
            CT.eventList,
            CT.cardSlider,
            CT.detailedList,
            CT.card,
            CT.cardList,
          ],
          applicable: "design",
          name: "infiniteScroll",
          defaultValue: 0,
          tooltip: {
            url: "https://help.display.church/en/articles/4616123-design-events-infinite-scroll",
            message:
              "For event lists only: just the month’s events or all events.",
          },

          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Infinite scroll parent selector",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
          ],
          applicable: "design",
          name: "infiniteScrollParentSelector",
          defaultValue: "",
          tooltip: null,
          show: [
            {
              field: "infiniteScroll",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "text",
            options: {
              placeholder: "Optional selector",
            },
          },
        },
        {
          title: "Limit displayed events",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.weekly,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventsNumber",
          defaultValue: "all",
          applicable: "design",
          tooltip: {
            url: "https://help.display.church/en/articles/4593620-design-events-number-of-events",
            message:
              "Filter events per timeline or limit # displayed for full calendars and events lists.",
          },
          show: [
            {
              field: "infiniteScroll",
              value: 0,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "radio",
            options: {
              radioOptions: [
                {
                  title: "Show all events for selected month",
                  value: "all",
                  template: [
                    CT.monthly,
                    CT.eventList,
                    CT.weekly,
                    CT.detailedList,
                    CT.card,
                    CT.cardList,
                    CT.bubble,
                  ],
                },
                {
                  title: "Show only upcoming events",
                  value: "upcoming",
                  template: [
                    CT.card,
                    CT.cardList,
                    CT.cardSlider,
                    CT.monthly,
                    CT.eventList,
                    CT.weekly,
                    CT.detailedList,
                    CT.bubble,
                  ],
                },
                {
                  title: "Show",
                  value: "upcoming-limit",
                  template: [
                    CT.eventList,
                    CT.card,
                    CT.cardList,
                    CT.cardSlider,
                    CT.detailedList,
                    CT.bubble,
                  ],
                  input: {
                    defaultValue: 3,
                    postLabel: "upcoming events",
                    type: "number",
                  },
                },
                {
                  title: "Show current week events only",
                  value: "current_week",
                  template: [
                    CT.card,
                    CT.cardList,
                    CT.cardSlider,
                    CT.detailedList,
                  ],
                },
                {
                  title: "Show only events within this time range",
                  value: "date_range",
                  template: [CT.weekly, CT.card, CT.cardList, CT.cardSlider],
                  input: {
                    type: "daterange",
                    defaultValue: "",
                  },
                },
              ],
            },
          },
        },
        {
          title: "Show event page scroll",
          templates: [
            CT.eventList,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
          ],
          name: "showUpcomingNavigation",
          defaultValue: 0,
          tooltip: null,
          applicable: "design",
          /*dependency: {
            name: "eventsNumberOption",
            value: "upcoming",
            defaultValue: "upcoming-limit",
            message:
              'This option requires "Show upcoming events" behavior to be turned on',
          },*/
          show: [
            {
              field: "eventsNumberOption",
              value: "upcoming-limit",
              defaultValue: "upcoming",
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Sort order",
          templates: [
            // CT.eventList,
            CT.card,
            CT.cardList,
          ],
          name: "dateRangeSortOrder",
          defaultValue: "chronological",
          tooltip: null,
          applicable: "design",

          show: [
            {
              field: "eventsNumberOption",
              value: "date_range",
              defaultValue: "upcoming",
            },
          ],
          control: {
            kind: "radio",
            options: {
              radioOptions: [
                {
                  title: "Chronological",
                  value: "chronological",
                  template: [CT.eventList, CT.card, CT.cardList],
                },
                {
                  title: "Upcoming first, past below",
                  value: "upcoming-first",
                  template: [CT.eventList, CT.card, CT.cardList],
                },
              ],
            },
          },
        },
      ],
    },
  ],
};
